import { useState } from "react";
import "../styles/SizeGuide.css";

export default function SizeGuide({ isMobile, isOpen, onClose }) {
  const [unit, setUnit] = useState("in");
  const [hoveredCell, setHoveredCell] = useState({ row: null, col: null });

  // Measurement data
  const measurements = {
    in: [
      {
        size: "S",
        waist: "30-32",
        hip: "42",
        thigh: "27",
        inseam: "5.5",
        outseam: "15.0",
        // waistbandDepth: "1.8",
        // bottomHem: "0.8",
      },
      {
        size: "M",
        waist: "32-34",
        hip: "44",
        thigh: "28",
        inseam: "5.5",
        outseam: "15.5",
        // waistbandDepth: "1.8",
        // bottomHem: "0.8",
      },
      {
        size: "L",
        waist: "34-36",
        hip: "46",
        thigh: "29",
        inseam: "5.5",
        outseam: "16",
        // waistbandDepth: "1.8",
        // bottomHem: "0.8",
      },
      {
        size: "XL",
        waist: "36-38",
        hip: "48",
        thigh: "30",
        inseam: "5.5",
        outseam: "16.5",
        // waistbandDepth: "1.8",
        // bottomHem: "0.8",
      },
    ],
    cm: [
      {
        size: "S",
        waist: "76-81",
        hip: "106.7",
        thigh: "68.6",
        inseam: "14.0",
        outseam: "38.1",
        // waistbandDepth: "4.6",
        // bottomHem: "2.0",
      },
      {
        size: "M",
        waist: "81-86",
        hip: "111.8",
        thigh: "71.1",
        inseam: "14.0",
        outseam: "39.4",
        // waistbandDepth: "4.6",
        // bottomHem: "2.0",
      },
      {
        size: "L",
        waist: "86-91",
        hip: "116.8",
        thigh: "73.7",
        inseam: "14.0",
        outseam: "40.6",
        // waistbandDepth: "4.6",
        // bottomHem: "2.0",
      },
      {
        size: "XL",
        waist: "91-97",
        hip: "121.9",
        thigh: "76.2",
        inseam: "14.0",
        outseam: "41.9",
        // waistbandDepth: "4.6",
        // bottomHem: "2.0",
      },
    ],
  };

  const headers = [
    `SIZE (${unit})`,
    "WAIST (A)",
    "HIP (B)",
    "THIGH (C)",
    "INSEAM (D)",
    "OUTSEAM (E)",
    // "WASITBAND DEPTH (F)",
    // "BOTTOM HEM HEIGHT (G)",
  ];
  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="size-guide-overlay"
          onClick={onClose} // Close the size guide when clicking the overlay
        ></div>
      )}
      <div
        className={`size-guide-container ${isMobile ? "mobile" : "desktop"} ${
          isOpen ? "open" : "closed"
        }`}
      >
        <div className="size-guide-content">
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
          <h2>Product Measurements</h2>
          <p>These measurements reflect the product's dimensions.</p>
          <div className="size-table-wrapper">
            <table className="size-table">
              <thead>
                <tr>
                  {headers.map((header, colIndex) => (
                    <th
                      key={colIndex}
                      className={`${
                        hoveredCell && hoveredCell.col === colIndex
                          ? "navy"
                          : ""
                      }`}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {measurements[unit].map((measurement, rowIndex) => (
                  <tr key={measurement.size}>
                    {Object.entries(measurement).map(
                      ([key, value], colIndex) => (
                        <td
                          key={`${rowIndex}-${colIndex}`}
                          className={`${
                            hoveredCell &&
                            hoveredCell.row === rowIndex &&
                            hoveredCell.col === colIndex
                              ? "navy"
                              : hoveredCell &&
                                ((hoveredCell.row === rowIndex &&
                                  colIndex < hoveredCell.col) ||
                                  (hoveredCell.col === colIndex &&
                                    rowIndex < hoveredCell.row))
                              ? "white"
                              : ""
                          }`}
                          onMouseEnter={() =>
                            setHoveredCell({ row: rowIndex, col: colIndex })
                          }
                          onMouseLeave={() => setHoveredCell(null)}
                        >
                          {value}
                        </td>
                      )
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="measurement-toggle">
            <div className="toggle-pill">
              <button
                className={`pill-option ${unit === "in" ? "active" : ""}`}
                onClick={() => setUnit("in")}
              >
                IN
              </button>
              <button
                className={`pill-option ${unit === "cm" ? "active" : ""}`}
                onClick={() => setUnit("cm")}
              >
                CM
              </button>
            </div>
          </div>
        </div>
        <div className="measurement-guide-content">
          <h2>Measurement Guide</h2>
          <p>
            Measure close to the body with a fabric tape measure or use a
            similar style garment to ensure the most accurate measurements.
          </p>
          <img src="/MeasurementGuide.png" alt="Measurement Guide" />
        </div>
      </div>
    </>
  );
}
